/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import { debugLog } from "../../helpers/debug";
import { useAuth } from "../auth";
import { useFirebase } from "../Firebase";

import {
  getObjFromLink,
  transformCollectionSnap,
  transformDocSnap,
} from "../helpers";

const FillsContext = createContext({});

export const FillsProvider = ({ children }) => {
  const firebase = useFirebase();
  const { claims } = useAuth();

  const [monthlyFills, setMonthlyFills] = useState();
  const [totalFills, setTotalFills] = useState();

  useEffect(() => {
    if (!claims?.companyLink) {
      debugLog(
        "[FillsProvider] No companyLink, skipping monthlyFills listener"
      );

      return () => {};
    }

    debugLog("[FillsProvider] Setting up monthlyFills listener");

    return firebase.db
      .collection("reports_fill_count")
      .doc(`${getObjFromLink(claims.companyLink).id}`)
      .collection("monthlyFills")
      .onSnapshot(
        snap => setMonthlyFills(transformCollectionSnap(snap)),
        err => debugLog(err)
      );
  }, [
    claims.companyLink,
    firebase,
  ]);

  useEffect(() => {
    if (!claims?.companyLink) {
      debugLog("[FillsProvider] No companyLink, skipping totalFills listener");
      return () => {};
    }

    debugLog("[FillsProvider] Setting up totalFills listener");

    return firebase.db
      .collection("reports_fill_count")
      .doc(`${getObjFromLink(claims.companyLink).id}`)
      .onSnapshot(
        snap => setTotalFills(transformDocSnap(snap)),
        err => debugLog(err)
      );
  }, [
    claims.companyLink,
    firebase,
  ]);

  const getKegMonthlyFills = useCallback(
    (kegId, setFills) => {
      const month = new Date().getMonth();
      const year = new Date().getFullYear();

      return firebase.db
        .collection("kegs")
        .doc(kegId)
        .collection("monthlyFills")
        .doc(`${year}-${month}`)
        .onSnapshot(
          snap => setFills(transformDocSnap(snap)),
          err => debugLog(err)
        );
    },
    [
      firebase,
    ]
  );

  return (
    <FillsContext.Provider
      value={{
        getKegMonthlyFills,
        monthlyFills,
        totalFills,
      }}
    >
      {children}
    </FillsContext.Provider>
  );
};

export const FillsConsumer = FillsContext.Consumer;

export const useFills = () => useContext(FillsContext);
